'use strict';

import ArgValidator from 'bam-arg-validator';
const ALLOWED_KEYS = ['watch', 'preview', 'recap', 'audio', 'vidhighlights', 'tickets', 'buysell',
    'promotions', 'hotels', 'flights', 'wrap'];

/**
 * Subclasses of this base class represent a group of BamButton subclass instances.
 */
class BamButtonGroup {

    constructor(suppAllowedKeys) {
        this._allowedKeys = ALLOWED_KEYS.concat(suppAllowedKeys);
        this._buttonArray = [];
    }

    /**
     * Checks that the specified key is an expected one,then adds the BamButton to this object as a top-level
     * property (this way, consumers can read this object as a simple map of keys to buttons).
     * @param {string} key Any key in allowedKeys
     * @param {BamButton} bamButton a BamButton subclass instance
     * @note order matters for function getButtonArray
     * @protected
     */
    addButton(key, bamButton) {
        ArgValidator.validateArgs(arguments, ['key', 'bamButton'], ['string', 'object'], [true, true]);
        ArgValidator.validateAllowed(key, this._allowedKeys);

        if (this.hasOwnProperty(key)) {

            throw new RangeError(`Button with key: ${key} already exists`);

        }

        this._buttonArray.push(bamButton);
        this[key] = bamButton;
    }

    /**
     * Get all buttons as an array ordered in the same way by which they were added
     * @returns {Array} of BamButton objects
     */
    getButtonArray() {

        return this._buttonArray;

    }
}

export default BamButtonGroup;

